//graphql.schemaに追加したら削除
export enum MeetingRoleType {
  MODERATOR = "MODERATOR",
  MONITOR = "MONITOR",
}
